import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import * as styles from './index.module.css'
import Link from '../Link'
import Button from '../Button/'

const AlternateImageText = ({ title, subtitle, components }) => {
  let imageCards = []
  let textCards = []
  components.forEach((comp) => {
    if (comp.image) {
      imageCards.push(comp)
    } else {
      textCards.push(comp)
    }
  })
  let defaultLableColor = '#b43996'
  return (
    <div className={`${styles.fullwidthWrapper}`}>
      <div className={styles.container}>
        <div className={styles.imageCards}>
          {imageCards.map((card, idx) => {
            return (
              <div className={`${styles.card} ${styles.imageCard}`} key={idx}>
                <div className={styles.imageBox}>
                  <GatsbyImage
                    image={card.gatsbyImageData}
                    className={styles.cardImg}
                    alt={card?.image?.description}
                  />
                </div>
                <div className={styles.textCard}>
                  <h2>{card.title}</h2>
                  <h4
                    style={{
                      color:
                        card.subtitle.subtitle.split('\n')[0].split(';')
                          .length > 1
                          ? card.subtitle.subtitle.split('\n')[0].split(';')[1]
                          : defaultLableColor,
                    }}
                  >
                    {card.subtitle.subtitle.split('\n')[0].split(';')[0]}
                  </h4>
                  <div className="paragraph">
                    {card.subtitle.subtitle.split('\n')[1]}
                  </div>
                  {card.ctaUrl && card.ctaText && (
                    <div className={styles.buttonContainer}>
                      <Link to={card.ctaUrl}>
                        <Button className={styles.joinUsButton}>
                          {card.ctaText}
                        </Button>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            )
          })}
        </div>
        <div className={styles.textCards}>
          {textCards.map((card, idx) => (
            <div className={styles.textOnlyCard} key={idx}>
              <div className={styles.textCard}>
                <h2>{card.title}</h2>
                <h4
                  className={styles.label}
                  style={{
                    color:
                      card.subtitle.subtitle.split('\n')[0].split(';').length >
                      1
                        ? card.subtitle.subtitle.split('\n')[0].split(';')[1]
                        : defaultLableColor,
                  }}
                >
                  {card.subtitle.subtitle.split('\n')[0].split(';')[0]}
                </h4>
                <p className={`${styles.description} paragraph`}>
                  {card.subtitle.subtitle.split('\n')[1]}
                </p>
                {card.ctaUrl && card.ctaText && (
                  <div className={styles.buttonContainer}>
                    <Link to={card.ctaUrl}>
                      <Button className={styles.joinUsButton}>
                        {card.ctaText}
                      </Button>
                    </Link>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default AlternateImageText
